import React, { useEffect, useState } from "react";
import "./admintable.css";
import Topbar from "../Global/topbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TableBody2 from "../Table container/tablebody";
import CachedIcon from "@mui/icons-material/Cached";
import { getAdmin } from "../../services/api/admin";
import { useGlobalPagination } from "../Global/Pagination/paginationStore";
import GlobalSearch from "../Global/GlobalSearch";

export default function AdminTable() {
  const navigate = useNavigate();
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const menu = true;
  const location = useLocation();
  const [reload, setReload] = useState();
  const deleted = true;
  const activete_data = "true";
  const resetdata = true;

  const {
    limit,
    search,
    lastKeys,
    setLastKey,
    page,
    setTotal,
    reset,
    pathname,
    setPathName,
    restoreState,
    skip,
  } = useGlobalPagination();

  useEffect(() => {
    const stored = localStorage.getItem("pagination-storage");
    if (pathname !== location.pathname) {
      reset();
      setPathName(location.pathname);
    } else {
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.state) {
          restoreState(parsed.state);
        }
      }
      setPathName(location.pathname);
    }
  }, [reset]);

  const handleclick = () => {
    navigate("/admin/super_admin/create_super_admin");
  };

  const headers = [
    { topic: "#" },
    { topic: "Name" },
    { topic: "Id" },
    { topic: "Role" },
    { topic: "Email" },
    // {topic : 'Phone Number'},
    { topic: "Active" },
    // {topic : 'Photo'},
    { topic: "Action" },
  ];

  const fetchAdmin = async () => {
    const lastKey = page > 1 ? lastKeys[page - 1] : null;

    getAdmin(search, limit, lastKey)
      .then((response) => {
        if (response.data.status) {
          if (response?.data?.data?.data.length === 0) {
            setLoder(false);
            setNotFound(true);
            setData(true);
            setTotal(response?.data?.data?.total);
          } else {
            setLoder(false);
            setNotFound(false);
            setData(true);
            setTotal(response?.data?.data?.total);
            setAPIdata(response?.data?.data?.data || []);
            setLastKey(page, response?.data?.data?.last_key);
          }
        } else {
          setLoder(false);
          setNotFound(true);
        }
      })
      .catch((error) => {
        setLoder(false);
        setNotFound(true);
        console.log(error.message);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoder(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchAdmin();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search, skip, limit, reload]);

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  const cell = [
    { topic: "name" },
    { topic: "id" },
    { topic: "role" },
    { topic: "email" },
    // {topic : 'number'},
    { topic: "activate" },
    // {topic : 'photo'}
  ];

  const path = "/admin/super_admin/admin_details";

  return (
    <div className="AdminTable-main">
      <div className="AdminTable-user">
        <Topbar />
        <div className="top-mid-Admin">
          <h1>Admin List</h1>
          <Link to="" style={{ display: "none" }}>
            Dashboard
          </Link>{" "}
          <Link to="/admin/super_admin">Admin List</Link> &#62;
        </div>
        <div className="tob-bottom-Admin">
          <div className="button-box-user">
            <button onClick={handleclick}> + Create Admin</button>
          </div>
          <div>
            <GlobalSearch />
            <button onClick={handleReload}>
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path={path}
            loader={loader}
            notfound={notfound}
            data={data}
            menu={menu}
            deleted={deleted}
            newPage={page}
            setReload={setReload}
            activete_data={activete_data}
            resetdata={resetdata}
          />
        </div>
      </div>
    </div>
  );
}
